const dtf = (o: Intl.DateTimeFormatOptions) =>
  new Intl.DateTimeFormat('es-ES', { timeZone: 'Europe/Madrid', ...o });

/** «lunes 12 oct, 18:00» */
export const fmtSnapshot = (iso: string) =>
  dtf({ weekday: 'long', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }).format(
    new Date(iso),
  );

/** «12 oct» */
export const fmtShort = (iso: string) => {
  const d = /^\d{4}-\d{2}-\d{2}$/.test(iso) ? new Date(`${iso}T12:00:00`) : new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : dtf({ day: 'numeric', month: 'short' }).format(d);
};

export const plusDays = (n: number) => {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
};

export const shortCommunity = (name: string) => name.replace(/^(CP |[A-E] - )/, '');
